import { AssetType, NODE_TYPES } from '@metavrse-inc/metavrse-lib';

export const uploadableWithoutConvertionAssetTypes: Record<string, AssetType> =
  {
    fbx: NODE_TYPES.object,
    glb: NODE_TYPES.object,
    spz: NODE_TYPES.object,
    obj: NODE_TYPES.object,
    c3b: NODE_TYPES.object,
    jpg: NODE_TYPES.image,
    jpeg: NODE_TYPES.image,
    tiff: NODE_TYPES.image,
    gif: NODE_TYPES.image,
    png: NODE_TYPES.image,
    js: NODE_TYPES.javascript,
    css: NODE_TYPES.stylesheet,
    html: NODE_TYPES.HTML,
    aac: NODE_TYPES.video,
    m4a: NODE_TYPES.video,
    mp4: NODE_TYPES.video,
    mp3: NODE_TYPES.video,
    mov: NODE_TYPES.video,
    hdr: NODE_TYPES.image,
  };
